<template>
	<div>
		<v-container fluid class="home-1 px-0">
			<v-container class="content-wrap pt-10">
				<v-row class="mt-10 mt-md-0">
					<v-col cols="12" lg="5" md="5" sm="5" class="flex-center flex-column pr-10">
						<h1 class="blue-text bold display-2 w-100 text-left hidden-md-and-down">
							Digitalna platforma <br>
							za škole
						</h1>
						<h1 class="blue-text bold display-1 w-100 text-left hidden-lg-and-up">
							Digitalna platforma <br>
							za škole
						</h1>
						<p class="mt-5 text--secondary w-100 text-left mb-0">
							Koordinacija ministara obrazovanja, znanosti, kulture i športa županija
							u kojima se nastavni planovi i programi izvode na hrvatskom jeziku u
							suradnji sa Sveučilištem u Mostaru
						</p>
						<div class="flex-left w-100 mb-4">
							<v-btn style="z-index: 9" to="/raspored" depressed rounded color="#094776" height="50" width="150" class="mr-4 moodle-btn font-weight-medium text-capitalize mt-8 white-text">
								Raspored sati
							</v-btn>
							<v-btn style="z-index: 9" @click.stop="dialog = true" depressed rounded outlined color="#DEE7EA" height="50" width="150" class="moodle-btn font-weight-medium video-btn text-capitalize mt-8 text--secondary">
								<v-icon style="font-size: 10px" class="mx-2">fas fa-play</v-icon> Promo video
							</v-btn>
						</div>
						<v-divider class="home-1-divider mt-3"></v-divider>
						<div class="flex-left w-100 powered-wrap mb-4 mb-lg-0">
							<p class="overline text--disabled mr-5 mb-0">POWERED BY</p>
							<a href="https://sumit.sum.ba" target="_blank" class="mr-6">
								<sumit></sumit>
							</a>
							<a href="https://carnet.hr" target="_blank">
								<carnet></carnet>
							</a>
						</div>
						<v-divider class="home-1-divider mb-4"></v-divider>
						<div class="flex-left w-100 powered-wrap">
							<p class="overline text--disabled mr-5 mb-0">TEHNOLOŠKI PARTNER</p>
							<a href="https://hteronet.ba" target="_blank">
								<eronet></eronet>
							</a>
						</div>
					</v-col>
					<v-col cols="12" lg="7" md="7" sm="7" class="flex-center">
						<v-img :src="require('@/assets/img/ilustracija.svg')" class="w-100" fluid></v-img>
					</v-col>
				</v-row>
			</v-container>
		</v-container>
		<v-container fluid class="home-2 flex-center" id="lekcije">
			<v-card class="mx-auto home-2-card">
				<v-container class="card-content flex-center flex-column mt-12 pb-10">
					<h1 class="text--primary w-100 text-center">Lekcije</h1>
					<p class="text--secondary w-100 text-center mt-5">
						Krajnji korisnici imaju mogućnost pregleda digitalnog sadržaja, prilagođenog uzrastu učenika, kojeg su izradili naši nastavnici. SUMIT je osigurao digitalni sadržaj za sve krajnje korisnike koji nemaju spremna online predavanja.
					</p>
					<div class="card-switch mt-5 flex-center">
						<div :class="{'active-switch': osnovna == true}" class="option-left flex-center" @click="changeType">
							<p class="ma-0 text-center w-100">Osnovna</p>
						</div>
						<div :class="{'active-switch': srednja == true}" class="option-right flex-center" @click="changeType">
							<p class="ma-0 text-center w-100">Srednja</p>
						</div>
					</div>
					<v-row v-if="osnovna" class="flex-center w-100 mt-10 class-list">
						<v-col v-for="(i, index) in razredi[0]" :key="index" cols="12" sm="6" md="4" class="pa-5">
							<router-link :to="'/predmeti/osnovna/' + i.grade" style="text-decoration: none;">
								<div class="class-item pa-5">
									<p class="blue-text text-uppercase font-weight-medium ma-0">
										<template v-if="i.grade == 10">
											Ostalo
										</template>
										<template v-else>
											{{ i.grade }}. Razred
										</template>
									</p>
									<v-icon color="#094776">keyboard_arrow_right</v-icon>
								</div>
							</router-link>
						</v-col>
					</v-row>
					<v-row v-if="srednja" class="flex-center w-100 mt-10 class-list">
						<v-col v-for="(i, key) in razredi[1]" :key="key" cols="12" sm="6" md="6" class="pa-5">
							<router-link :to="'/predmeti/srednja/' + i.grade" style="text-decoration: none;">
								<div class="class-item pa-5">
									<p class="blue-text text-uppercase font-weight-medium ma-0">
										{{ i.grade }}. Razred SŠ
									</p>
									<v-icon color="#094776">keyboard_arrow_right</v-icon>
								</div>
							</router-link>
						</v-col>
					</v-row>
					<div class="w-100 px-5 mt-5 pb-lg-10 pb-sm-12">
						<div class="my-alert w-100 py-4 px-3 flex-between">
							<div class="flex-center">
								<v-icon color="teal" class="mr-2">query_builder</v-icon>
								<p class="mb-0">Raspored nastave</p>
							</div>
							<v-btn rounded outlined color="teal" to="/raspored" class="moodle-btn text-capitalize">Pogledaj raspored</v-btn>
						</div>
					</div>
				</v-container>
			</v-card>
		</v-container>
		<v-parallax :src="require('@/assets/img/home-3.jpg')" class="home-3"></v-parallax>
		<v-container fluid class="home-4 py-12">
			<bubbles></bubbles>
			<v-container class="content-wrap">
				<v-img width="200px" class="mb-10" :src="require('@/assets/img/bijela.svg')"></v-img>
				<h1 class="title white-text bold">
					SUMIT Školarac je platforma za učenje na daljinu, koja omogućava otvaranje i pohađanje online tečajeva, komunikaciju, prezentaciju sadržaja, provjeru stečenog znanja, predaju i kontrolu zadaća te praćenje sudjelovanja.<br>
					Na Školarac se možete prijaviti putem @skole.sum.ba korisničkog računa.
				</h1>
				<v-btn style="z-index: 9" href="https://skolarac.sum.ba/login/login.html" target="_blank" depressed color="white" height="50" width="150" class="moodle-btn subtitle-2 font-weight-medium text-capitalize mt-8 blue-text mb-12">
					Posjeti Školarac
				</v-btn>
				<v-btn style="z-index: 9" rounded="" outlined="" href="https://skole.sum.ba/skolarac" color="white" height="50" width="150" class="ml-6 font-weight-medium subtitle-2 text-capitalize mt-8 mb-12">
					Više info
				</v-btn>
			</v-container>
			<svg class="diagonal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
				<polygon fill="#F0F5F7" points="0,100 100,0 100,100"/>
			</svg>
		</v-container>
		<v-container fluid class="home-5 flex-center py-12 flex-column" id="gsuite">
			<v-container class="content-wrap my-12 flex-center flex-column">
				<v-img :src="require('@/assets/img/G-Suite.png')" class="img fluid mb-2"></v-img>
				<p class="text--secondary text-center mt-10">
					Usluga omogućava korisnicima da uz korištenje @skole.sum.ba korisničkog računa pristupe Googleovim aplikacijama koje omogućavaju udaljeno učenje i suradnju. Uključuje Gmail e-poštu, Google disk (za pohranjivanje dokumenata u oblaku) u sklopu kojeg su dostupne aplikacije za online suradnju Google Dokumenti, Tablice i Prezentacije, zatim aplikaciju Hangouts (za tekstualne poruke, audio i videopozive) te platformu Google Classroom koja sadrži alate za učenje na daljinu.
				</p>
				<v-btn href="https://skole.sum.ba/gsuite" depressed color="#094776" height="50" width="150" class="moodle-btn text-capitalize mt-8 white-text">
					Otvori G-Suite
				</v-btn>
			</v-container>
			<v-container class="content-wrap flex-center my-12" id="novosti">
				<v-row class="flex-center mt-8 w-100">
					<v-col lg="4" md="6" cols="12" class="pa-3 flex-center w-100" v-for="i in news" :key="i.id">
						<v-card class="flex d-flex flex-column article-card" :href="'https://skole.sum.ba/novosti/' + i.alias" shaped flat>
							<div class="article-img-wrap">
								<v-img class="white--text img-fluid align-end article-img" height="200px"
								:src="'https://web-admin.sum.ba/api/storage/' + i.image"></v-img>
							</div>
							<v-card-subtitle class="pb-0">Novosti</v-card-subtitle>
							<v-card-title>
								<h3 class="title mb-0" style="overflow-y: auto; color: #084776">{{ i.title }}</h3>
							</v-card-title>
						</v-card>
					</v-col>
					<v-col lg="4" md="6" cols="12" class="pa-3 flex-center w-100">
						<v-card class="flex d-flex flex-column article-card" dark color="#094776" shaped flat>
							<logo class="ml-5 mt-5"></logo>
							<v-card-text class="headline font-weight-bold" style="overflow-y: auto;">Sve novosti i obavijesti
								vezane za digitalnu platformu u školstvu unutar županije.</v-card-text>
							<v-spacer></v-spacer>
							<v-card-actions class="">
								<v-btn rounded color="#FFF" link href="https://skole.sum.ba/novosti"
									class="text-capitalize subtitle-2 font-weight-medium moodle-btn blue-text pa-6 ml-2 mb-4">Pročitaj sve novosti</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-container>
		<v-container id="sumtv" class="content-wrap flex-center my-12 px-5">
			<v-row align="center" class="my-12 w-100 flex-center">
				<v-col cols="12" md="6" class="flex-left flex-column sumtv-col">
					<h2 class="mb-3 display-1 w-100"><b>SUM TV škola u programu RTV Herceg Bosne</b></h2>
					<span class="text--secondary mt-2">U vrijeme krize nastale zbog virusa COVID-19 uz platformu e-škole koja će omogućiti pristup nastavnim  sadržajima svim učenicima, kroz SUM TV Sveučilište u Mostaru u suradnji s RTV Herceg Bosne počinje emitirati pilot tjedan nastave za učenike od 1. do 5. razreda osnovne škole.</span>
					<v-btn depressed rounded height="50" width="180" class="text-capitalize subtitle-2 font-weight-medium moodle-btn mt-8 white-text" color="#084776" to="/sumtv">Otvorite SUM TV</v-btn>
				</v-col>
				<v-col cols="12" md="6" class="py-5">
					<v-img :src="require('@/assets/img/sumtv.png')" contain ></v-img>
				</v-col>
			</v-row>
		</v-container>

		<!-- VIDEO MODAL -->
		<v-dialog v-model="dialog">
			<div class="w-100 pa-4 text-right" style="background-color: #094776">
				<v-icon class="white-text" @click.stop="dialog = false">clear</v-icon>
			</div>
			<iframe class="w-100" height="700" src="https://www.youtube.com/embed/mjXljXzTfn0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</v-dialog>
	</div>
</template>

<script>
import Sumit from '../components/Sumit'
import Eronet from '../components/Eronet'
import Carnet from '../components/Carnet'
import Logo from '../components/Logo'
import Bubbles from '../components/Bubbles'

export default {
	name: "Home",
	components: {
		Sumit,
		Eronet,
		Carnet,
		Logo,
		Bubbles
	},
	data() {
		return {
			osnovna: true,
			srednja: false,
			razredi: [],
			news: [],
			dialog: false
		}
	},
	created() {
		skoleApi.get("razredi").then(response => {
			if(response.status === 200) {
				this.razredi = response.data;
			}
		})
	},
	mounted() {
    this.getNews();
  },
	methods: {
		changeType() {
			if (this.osnovna) {
				this.osnovna = false;
				this.srednja = true;
			} else {
				this.srednja = false;
				this.osnovna = true;
			}
		},
		getNews() {
      let requestBody = {
        page: this.page,
        postsPerPage: 2,
        categories: ["e-Škola"]
      };

      axios
        .post("https://web-admin.sum.ba/api/web/objave", requestBody)
        .then(response => {
          this.news = response.data;
          //   console.log(this.news);
        })
        .catch(error => console.log(error.message));
    }
	}
};
</script>

<style lang="scss" scoped>
.home-1 {
	padding-top: 100px;
	background-color: #F0F5F7;
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}
.home-1-divider {
	width: 100% !important;
}
.powered-wrap {
	padding: 16px 0;
	p {
		font-size: 10px !important;
		letter-spacing: 2px;
		white-space: nowrap;
	}
	a {
		display: flex;
		align-items: center;
	}
}
.home-2 {
	background-color: #F0F5F7;
	.home-2-card {
		width: 80vw;
		min-height: 50vh;
		box-shadow: none;
		border-radius: 20px !important;
		z-index: 10;
		display: flex !important;
		justify-content: center !important;
		align-items: center;
		.card-content {
			width: 80%;
			height: 80%;
			.card-switch {
				width: 50%;
				height: 56px;
				background-color: #F0F5F7;
				border-radius: 33px;
				.option-left, .option-right {
					width: 50%;
					height: 100%;
					border-radius: 33px;
					cursor: pointer;
				}
			}
		}
	}
}
.my-alert {
	background-color: rgba(0, 128, 128, 0.2);
	border-left: 4px solid teal;
	div {
		p {
			color: rgb(0, 128, 128)
		}
	}
}
@media (max-width: 768px) {
	.sumtv-col {
		.moodle-btn {
			width: 100% !important;
			margin-bottom: 20px;
		}
	}
	.btn-col {
		width: 100% !important;
	}
	.my-alert {
		flex-direction: column;
		.v-icon {
			display: none !important;
		}
		.moodle-btn {
			width: 100% !important;
			margin-top: 15px;
		}
	}
	.home-1 {
		padding-top: 90px !important;
	}
	.card-switch {
		width: 100% !important;
	}
}
.active-switch {
	background-color: #094776 !important;
	p {
		color: #FFF !important;
	}
}
.home-3 {
	width: 100vw;
	height: 50vh;
	margin-top: -150px;
}
.class-item {
	border: 1px solid #DEE7EA;
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	transition: .3s ease;
	cursor: pointer;
	&:hover {
		border: 1px solid #094776;
		transition: .3s ease;
	}
}
.home-4 {
	background-color: #094776;
	min-height: 60vh;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	.diagonal {
		position: absolute;
		bottom: 0;
		width: 100vw;
		height: 80px;
	}
}
.v-alert {
	div {
		width: 100% !important;
	}
}
.moodle-btn {
	letter-spacing: 0 !important;
	border-radius: 30px;
}
.video-btn {
	border-color: #DEE7EA !important;
}
.home-5 {
	min-height: 50vh;
}
.article-card {
	min-height: 390px;
	width: 100%;
	.article-img-wrap {
		max-height: 200px;
		display: inline-block;
		overflow: hidden;
		.article-img {
			transition: transform .4s;
		}
	}
	&:hover {
		.article-img {
			transform: scale(1.1);
			transform-origin: 50% 50%;
		}
	}
}
.card-link {
	position: relative;
}
.card-link-action {
	position: absolute;
	bottom: 35px;
	left: 10px;
}
.sumtv-col {
	align-items: flex-start !important;
}
</style>
